<template>
	<MaterialDateRangePicker :disabled="disabled" :name="name" v-model.trim="dateRange" :showDropdowns="showDropdowns"
		:clearButton="clearButton" :inputClasses="inputClasses" :error="error" :singleDatePicker="true"
		:dateFormat="dateFormat">
		<slot></slot>
	</MaterialDateRangePicker>
</template>

<script>
export default {
	name: 'material-datepicker',
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: null
		},
		value: {
			type: String,
			required: false,
			default: null,
		},
		dateFormat: {
			type: String,
			default: 'DD/MM/YYYY', //'YYYY-MM-DD HH:mm:ss'
		},
		databaseDateFormat: {
			type: String,
			default: 'YYYY-MM-DD HH:mm:ss',
		},
		showDropdowns: {
			type: Boolean,
			default: true,
		},
		clearButton: {
			type: Boolean,
			default: true
		},
		required: {
			type: Boolean,
			default: false
		},
		inputClasses: {
			type: [Array, Object, String],
			default: null
		},
		errorMessages: {
			type: [Array, String],
			default: null
		},
		error: {
			type: String,
			default: null
		},
	},
	data() {
		return {
			mutableValue: null,
			dateRange: {
				startDate: null,
				endDate: null,
			},
		}
	},
	methods: {
		// convertDateSI(date) {
		//   return date ? moment(date).format(this.dateFormat) : null;
		// },
		// convertDateLocale(date) {
		//   return date ? moment(date).format(this.dateFormat) : null;
		// },
		setValue(newValue) {
			this.dateRange = {
				startDate: newValue, //this.convertDateLocale(newValue),
				endDate: newValue, //this.convertDateLocale(newValue)
			};
		},
	},
	watch: {
		value: {
			immediate: true,
			handler: function (newValue, oldValue) {
				if(newValue) {
					this.setValue(newValue);
				}
			}
		},
		'dateRange.startDate': {
			immediate: false,
			handler: function (newValue, oldValue) {
				this.$emit('input', newValue ? moment(newValue).format(this.databaseDateFormat) : null);
			}
		},
	},
}
</script>
